'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./emotion-react.cjs.prod.js");
} else {
  module.exports = require("./emotion-react.cjs.dev.js");
}



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/react/dist/emotion-react.cjs.js
// module id = 95
// module chunks = 0